import serpFiltersModal from "./filtersModal";
import {MitulaSerpPageData} from "../SerpPage";
import {EventBus} from "../../../../common/ts/events/EventBus";
import eventHandlers from "./eventHandlers";
import {isDesktopDevice} from "../../device";
import operationTypeSelect from "../../components/userSearch/operationTypeSelect";
import dom from "../../../../common/ts/core/dom";
import location from "../../../../common/ts/core/location";
import propertyTypeSelect from "../../components/userSearch/propertyTypeSelect";
import {FiltersSubmittedEvent} from "./events";
import tracking from "../../../../common/ts/core/tracking";
import {getFormDataSubmittingInFilterBar} from "./filterFormData";
import {FILTERS_BAR_FORM_SELECTOR} from "./constants";
import {WlSubmit} from "../../../../common/ts/webcomponents/events/WlSubmit";
import {FILTER_NAMES} from "./constants";

const eventBus: EventBus = EventBus.getInstance();

function init(pageData: MitulaSerpPageData) {
    eventHandlers.init();
    serpFiltersModal.init(eventBus, pageData);
    registerSubmitButtonFiltersListener(pageData);
    const propertyTypedropdown = dom.select(`wl-dropdown[name=${FILTER_NAMES.PROPERTY_TYPE}]`) as HTMLElement;
    propertyTypedropdown?.addEventListener(WlSubmit.type, emitSubmit as EventListener);
}
function emitSubmit (e: CustomEvent) {
    e.preventDefault();
    const searchParams = new URLSearchParams(location.getQueryParams());
    const formData = getFormDataSubmittingInFilterBar()

    eventBus.emitMany([
        new FiltersSubmittedEvent({
            formData,
            searchParams,
            type: FiltersSubmittedEvent.FORM_TYPE
        }),
        new tracking.TrackAmplitudeEvent({
            type: "FiltersUpdated",
            serpUrl: window.location.href,
            filters: getPriceFilters(formData)
        })
    ])
}

function registerSubmitButtonFiltersListener(pageData: MitulaSerpPageData) {
    eventBus.emit(new dom.AddClickListenerEvent({
       selector: "#priceRangeFilter_apply",
        listener: emitSubmit
    }));

    eventBus.emit(new dom.AddClickListenerEvent({
        selector: "#minBedrooms_apply",
        listener: function (e: Event) {
            e.preventDefault();

            const searchParams = new URLSearchParams(location.getQueryParams());
            eventBus.emitMany([
                new FiltersSubmittedEvent({
                    formData: getFormDataSubmittingInFilterBar(),
                    searchParams,
                    type: FiltersSubmittedEvent.FORM_TYPE,
                }),
                new tracking.TrackAmplitudeEvent({
                    type: "FiltersUpdated",
                    serpUrl: window.location.href,
                    filters: getMinBedroomsFilter(getFormDataSubmittingInFilterBar()),
                })
            ])
        }
    }));

    if (isDesktopDevice(pageData.device)) {
        operationTypeSelect.init(FILTERS_BAR_FORM_SELECTOR);
        propertyTypeSelect.init(pageData.propertyType);
    }
}

function getPriceFilters(formData: { [key: string]: string }){
    const prices: { minPrice?: string, maxPrice?: string } = {}
    if (formData["minPrice"] !== "") prices["minPrice"] = formData["minPrice"];
    if (formData["maxPrice"] !== "") prices["maxPrice"] = formData["maxPrice"];
    return prices;
}

function getMinBedroomsFilter(formData: { [key: string]: string }){
    const bedrooms: { minBedrooms?: string } = {}
    if (formData["minBedrooms"] !== "") bedrooms["minBedrooms"] = formData["minBedrooms"];
    return bedrooms;
}

export default {
    init,
}
